export default "__VITE_PUBLIC_ASSET__92f93cdf__"